<template>
  <div id="app" class="orange-theme">
    <router-view />
  </div>
</template>

<script setup>
import { onMounted, onUnmounted, watch } from 'vue'
import { useUserStore } from '@/stores/user'

const userStore = useUserStore()

const mountProductReleaseAnnouncement = () => {
  const apiBase = String(import.meta.env.VITE_ERP_API_BASE || 'https://erp.jonmall.com').replace(/\/+$/, '')
  const mount = () => window.JinzhiProductRelease?.mount({ system: 'saas', platform: 'web', apiBase })
  if (window.JinzhiProductRelease) return mount()
  if (document.querySelector('script[data-product-release-loader]')) return
  const script = document.createElement('script')
  script.src = `${apiBase}/components/product-release-announcement.js`
  script.dataset.productReleaseLoader = '1'
  script.onload = mount
  document.head.appendChild(script)
}

const stopReleaseAnnouncementWatch = watch(
  () => userStore.isAuthenticated,
  authenticated => { if (authenticated) mountProductReleaseAnnouncement() }
)

onMounted(() => {
  // 初始化用户认证状态
  userStore.initAuth()

  // ✅ 【新增】启动会话超时检查定时器（每分钟检查一次）
  const sessionCheckInterval = setInterval(() => {
    if (userStore.isAuthenticated && userStore.isSessionExpired()) {
      console.warn('会话已过期，执行强制登出')
      userStore.forceLogout()
      clearInterval(sessionCheckInterval)
    }
  }, 60 * 1000) // 每60秒检查一次

  // 保存定时器ID以便组件卸载时清除
  window.__sessionCheckInterval = sessionCheckInterval
})

// ✅ 【新增】组件卸载时清除定时器
onUnmounted(() => {
  if (window.__sessionCheckInterval) {
    clearInterval(window.__sessionCheckInterval)
  }
  stopReleaseAnnouncementWatch()
})
</script>

<style lang="scss">
// 全局样式
html, body, #app {
  height: 100%;
  margin: 0;
  padding: 0;
  font-family: 'Helvetica Neue', Helvetica, 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', '微软雅黑', Arial, sans-serif;
}

// 滚动条样式
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-track {
  background: var(--el-bg-color-page);
}

::-webkit-scrollbar-thumb {
  background: var(--el-border-color-darker);
  border-radius: 3px;
}

::-webkit-scrollbar-thumb:hover {
  background: var(--el-border-color-dark);
}

// Element Plus 组件样式覆盖
.el-message {
  min-width: 200px;
}

.el-notification {
  width: 350px;
}

// 响应式布局辅助类
.mobile-hidden {
  @media (max-width: 768px) {
    display: none !important;
  }
}

.desktop-hidden {
  @media (min-width: 769px) {
    display: none !important;
  }
}

// 动画效果
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.slide-enter-active,
.slide-leave-active {
  transition: transform 0.3s ease;
}

.slide-enter-from {
  transform: translateX(-100%);
}

.slide-leave-to {
  transform: translateX(100%);
}
</style>
